interface TextareaProps {
  identifier: string;
  errors: string[];
  maxCharacterLimit?: number;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
}

export default function Textarea({
  identifier,
  errors,
  maxCharacterLimit,
  value,
  placeholder,
  onChange
}: TextareaProps) {
  const hasError = maxCharacterLimit && maxCharacterLimit < value.length;

  const inputClasses = hasError
    ? 'border-error-300 text-error-300 bg-error-75'
    : 'border-neutral-500';

  const characterCounterClasses = hasError
    ? 'text-error-300'
    : 'text-neutral-400';

  return (
    <div className="flex flex-col">
      <textarea
        id={identifier}
        name={identifier}
        className={`${inputClasses} border rounded px-4 py-2 transition-all outline-none resize-none text-sm`}
        value={value}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
      <div className="grid grid-cols-12 items-center">
        <div className="col-span-12 lg:col-span-10">
          {errors.map((error, index) => (
            <p key={index} className="text-error-300 text-sm">
              {error}
            </p>
          ))}
        </div>
        <div className="col-span-12 lg:col-span-2">
          {maxCharacterLimit ? (
            <div
              className={`${characterCounterClasses} text-right text-xs py-1`}
            >
              {value.length} / {maxCharacterLimit}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
